import { Nullable } from 'modules/types/common';
import { getRegisterBrand } from 'store/register/utils';

export interface RegisterState {
  isSubmitting: boolean;
  previousStep: string;
  currentStep: string;
  error: Nullable<Error>;
  alert: RegisterAlert;
  data: RegisterData;
  meta: RegisterMeta;
  mobileRegistrationSession: boolean;
  isAccountAlreadyExist: boolean;
  accountCreationInfo: boolean;
}

export interface RegisterAlert {
  severity?: 'error' | 'warning' | 'info' | 'success';
  title?: string;
  message?: string;
}

export interface RegisterData {
  firstName: string;
  lastName: string;
  dateOfBirth: Nullable<string>;
  consumerId?: Nullable<string>;
  shSubscriberNumber?: Nullable<string>;
  pharmacyPlanId?: Nullable<string>;
  medicaidId?: Nullable<string>;
  insuranceId?: string;
  gender: string;
  ethnicity: string;
  streetAddress: string;
  unitNumber: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone: string;
  email: string;
  username: string;
  password: string;
  ssn: string;
  registrationStatus: string;
  termsAcceptance: Nullable<{
    type: string;
    version: string;
    date: string;
  }>;
}

export interface RegisterMeta {
  insuranceType: string;
  insuranceId: string;
}

export enum CreacteAccountOptions {
  NO = 'No, I do not have any log in',
  YES = 'Yes, I do have log in information'
}

export function getInsuranceType() {
  const branding = getRegisterBrand();
  return {
    SH_SUBSCRIBER: branding !== RedirectBrand.SC ? 'Select Health' : 'Scripius',
    ...(branding !== RedirectBrand.SC ? { MEDICAID: 'Medicaid' } : undefined),
    NONE: "I don't have a number or they are not applicable"
  };
}

export enum AlertType {
  ERROR = 'error',
  INFO = 'info'
}

export enum UnifiedRedirectActions {
  urlOnComplete = 'urlOnComplete',
  urlOnCancel = 'urlOnCancel',
  urlOnError = 'urlOnError',
  urlOnExisting = 'urlOnExisting',
  urlOnForgetUserName = 'urlOnForgetUserName'
}
export type UnifiedRedirectKey = keyof typeof UnifiedRedirectActions;

export enum RedirectBrand {
  MHP = 'mhp', // default - blank or mhp
  ORG = 'org', // intermoutainhealthcare.org - Should have intermountain brand
  SH = 'sh', // Select health
  SC = 'sc' // Scripius
}
